(function () {
   'use strict';

   // document.addEventListener('DOMContentLoaded', function () {
   // Get config from Theme object if it exists
   // CustomAOS will use its own defaults for any missing values
   const themeConfig = window.Theme && window.Theme.aos ? window.Theme.aos : {};
   // console.log(window.Theme);
   // console.log(themeConfig);

   // Initialize CustomAOS with Theme config (overrides library defaults)
   CustomAOS.init(themeConfig);
   // });

   window.AOS = CustomAOS;
})();
